import Store from "../../../../Store";

const langImg = {
  continueLearning: {},
  allLessons: {},
  lessonsList: {},
  learningLevel: {},
  yourActivity: {},
  activeCourse: {},
  otherCourses: {},
  sidebarMenu: {},
  lessonTutorial: {},
  test: {},
};

const getTutorialImage = (imgName, langShort) => {
  return langImg[imgName][langShort];
};

export const isTutorialAvailable = () => {
  const lang = Store.getUserPlatformLangShort();
  return Object.values(langImg).every((imageObj) => !!imageObj[lang]);
};

export default getTutorialImage;
